<template>
  <w-modal :value="value" :width="448" @close="onClose">
    <h1 slot="header">{{ title }}</h1>
    <div slot="content" class="modal-content">
      <h2 class="modal-content__title">{{ order.name }}</h2>
      <p class="modal-content__description">透過分享連結邀請人員加入訂購，方便後續訂購流程。</p>
      <div class="modal-content__link">
        <h3 class="modal-content__link--title">訂購連結</h3>
        <div class="modal-content__link--wrapper">
          <div>
            <p>
              「{{ order.name }}」已開放訂購，請於 {{ orderEndTime }} 前下單唷。
            </p>
            <div class="level is-justify-content-flex-start">
              <a :href="`${orderLink}?openExternalBrowser=1`" target="_blank">{{ orderLink }}</a>
              <b-button
                type="is-ghost"
                class="modal-content__link--copy"
                v-clipboard:copy="orderLink"
                v-clipboard:success="onCopySuccess"
                v-clipboard:error="onCopyError">
                <span class="icon-link" />
                複製連結
              </b-button>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div slot="footer">
      <b-button
        type="is-primary"
        v-clipboard:copy="contentToCopy"
        v-clipboard:success="onCopySuccess.bind(this, { contentType: '訂購資訊' })"
        v-clipboard:error="onCopyError">
        複製訂購資訊
      </b-button>
    </div>
  </w-modal>
</template>

<script>
import CopyLinkModal from './CopyLinkModal';

export default CopyLinkModal;
</script>

<style lang="scss" scoped>
@import 'CopyLinkModal';
</style>
